<template>
  <utd-notice-dialog ref="dialog"
                     :title="C_LOCALIZATION.TRANSLATION_FEEDBACK_INSTRUCTION.TITLE"
                     :heading="C_LOCALIZATION.TRANSLATION_FEEDBACK_INSTRUCTION.HEADING"
                     :body-bullets="C_LOCALIZATION.TRANSLATION_FEEDBACK_INSTRUCTION.BODY_TEXT_ARR"
                     icon-class="wkce-icon-filled-info" />
</template>

<script lang="ts" setup>
import UtdNoticeDialog from '_acaSrc/components/shared/stdlib/UtdNoticeDialog.vue';
import { C_LOCALIZATION } from '_acaSrc/utility/constants';
import { ref } from 'vue';

const dialog = ref(null);
const open = () => {
    dialog.value.openModal();
};
const close = () => {
    dialog.value.closeModal();
};

defineExpose({
    open,
    close
});

</script>

<style lang="less" scoped>
  @import (reference) '~_acaAssets/wkce/colors/wkce-app-styles';

  .translation-feedback__heading {
    .ds1-flex-vertical-center();
  }

  .translation-feedback__heading-label {
    .ds1-utd-size-6();
    .ds1-ml-2();
    .ds1-utd-weight-bold();
  }

  .translation-feedback__content {
    .ds1-ml-4();
  }

  .wkce-icon-filled-info {
    .ds1-ma-0();
    font-size: 24px;
    color: @DS1-UTD-INFO;
  }

  .translation-feedback__content-details {
    .ds1-ml-3();
    .ds1-mt-1();
    padding-inline-start: 44px;
    li {
      .ds1-pb-1();
    }
  }
</style>

<style lang="less">
  @import (reference) '~_acaAssets/wkce/colors/wkce-app-styles';

  @media only screen and (min-width: 768px) {
    .alert-modal-dialog .utd-dialog-frame .utd-dialog-footer {
      flex-direction: row;
      gap: 0;
    }
  }

  .alert-modal-dialog {
    .utd-modal-content {
      .utd-dialog-frame {
        max-width: 600px;
        .utd-dialog-header {
          .ds1-utd-weight-bold();
          font-size: 20px;
        }
        .utd-dialog-content {
          .ds1-pa-4();
          .ds1-pb-0();
        }
      }
    }

    .utd-dialog-footer {
      flex-wrap: wrap;
      align-content: flex-end;
      flex-direction: column-reverse; /* stylelint-disable-line declaration-block-no-redundant-longhand-properties */
      gap: 16px;
    }
  }
</style>